import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Container, Card, Row, Col, Form, Table } from 'react-bootstrap';
import { Loader } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import * as yup from 'yup';
// import Header from '../../components/common/Header/Header';
const EligibilityRelationships = (props) => {
  const { onChange } = props;
  const { values, errors, errorValidation, relationshipData, relationNames } =
    props;
  console.log('values', values);
  return (
    <Row className="Payment-details">
      <Col md={4} lg={4} sm={4} className="padding-0">
        <h3>Eligible Relationships</h3>
        <p>
          Select from standard family/dependent relationships who can be
          enrolled.
        </p>
      </Col>
      <Col md={8} lg={8} sm={8} className="setup-form">
        <div>
          <Table striped bordered hover className="m-0">
            <thead>
              <tr>
                <th style={{ textAlign: 'left' }}>Select</th>
                <th style={{ textAlign: 'left' }}>Relationship Description</th>
              </tr>
            </thead>
            <tbody>
              {relationshipData.map((rel, key) => {
                {
                  return (
                    <tr key={rel.Code}>
                      <td>
                        <Form.Group id="formGridresetFirstName">
                          <Form.Label
                            className="sr-only"
                            for="spouse"
                          ></Form.Label>
                          <Form.Check
                            type="checkbox"
                            checked={values[rel.Description]}
                            onChange={onChange}
                            id={rel.Description}
                            name={rel.Description}
                          />
                        </Form.Group>
                      </td>
                      <td>{rel.Description}</td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
        </div>
      </Col>
    </Row>
  );
};
export default EligibilityRelationships;
